import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const RequireApproval = () => {
  const { userData, loading } = useAuth();

  if (loading) return null;

  // TODO: 테스트용 - 승인 체크 우회
  return <Outlet />;

  // if (userData?.status !== 'approved') {
  //   return <Navigate to="/pending" replace />;
  // }
  // return <Outlet />;
};

export default RequireApproval;
